/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SnapchatLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M242.95264,194.51565c-7.17285,6.73242-17.44434,7.418-26.50684,8.02343-5.77881.38575-11.75391.78418-15.24658,2.707-3.37012,1.85546-6.84522,6.61914-10.20557,11.22558-5.40674,7.41113-11.53418,15.81152-21.2373,18.29395-9.356,2.39648-18.584-1.90625-26.72608-5.70118C137.688,226.57424,132.16357,224,128,224c-4.16309,0-9.6875,2.57422-15.02979,5.06445-6.51074,3.03321-13.71728,6.39161-21.126,6.39161a22.48462,22.48462,0,0,1-5.59961-.69043c-9.70361-2.48243-15.83154-10.88282-21.23877-18.29493-3.36035-4.60546-6.835-9.36914-10.20459-11.2246-3.49268-1.92286-9.46826-2.32129-15.24658-2.707-9.0625-.60546-19.334-1.291-26.50684-8.02343a7.99944,7.99944,0,0,1,2.085-13.07911c.27149-.13085,12.46192-6.085,24.44629-21.32324a107.03319,107.03319,0,0,0,17.35156-32.72558l-19.90136-7.96a7.99977,7.99977,0,0,1,5.9414-14.85547L61.023,111.793A163.22264,163.22264,0,0,0,64,80a64,64,0,0,1,128,0,163.22264,163.22264,0,0,0,2.977,31.793l18.05176-7.2207a8,8,0,0,1,5.94238,14.85547l-19.90137,7.96093a107.023,107.023,0,0,0,17.35157,32.72461c12.05957,15.334,24.32763,21.2666,24.45019,21.3252a8.021,8.021,0,0,1,2.08106,13.07715Z" />
    </Svg>
  );
}

export default SnapchatLogo;
